import React, { useState, useEffect,useRef } from "react";
import {
  FaChevronDown,
  FaLock,
  FaKey,
  FaUpload,
  FaDownload,
  FaSearch,
  FaShieldAlt,
  FaBox,
  FaGift,
  FaWallet,
  FaCloudUploadAlt,
  FaRedo
} from "react-icons/fa";
import {
  MdSecurity,
  MdVpnKey,
  MdBackup,
} from "react-icons/md";
import "./css/navbar.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";







const Navbar = ({ aboutRef , featuresRef,contactRef}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(localStorage.getItem("user"));
   const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = () => setUser(localStorage.getItem("user"));
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem("user");
    setUser(null);
    window.location.reload();
  };
   const handleUploadClick = (e) => {
    e.preventDefault();
    if (user) {
      navigate("/upload");
    } else {
      alert("You must sign in first to start uploading files.");
    }
  };

 return (
    <header className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <div className="logo">
          <img src="/assets/lifoura-04.png" className="logo-img" alt="best cloud storage" />
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-menu">
           <div className="nav-center-links">
          <a onClick={() => aboutRef.current?.scrollIntoView({ behavior: 'smooth' })} className="nav-link">About</a>
          <a  onClick={() => featuresRef.current?.scrollIntoView({ behavior: 'smooth' })} className="nav-link">Features</a>
          <a href="/blog" className="nav-link">Blog</a>
          <a onClick={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })}  className="nav-link">Contact</a>
          </div>

          <div className="nav-buttons">
          {!user ? (
            <button
              onClick={() => (window.location.href = "/signin")}
              className="btn sign-in"
            >
              Sign In
            </button>
          ) : (
            <button onClick={handleSignOut} className="btn sign-out">
              Sign Out
            </button>
          )}
          <button onClick={handleUploadClick} className="btn try-free">
            Start Now
          </button>
          </div>
        </nav>

        {/* Mobile Toggle */}
        <div className="menu-toggle">
            <button
    onClick={() => setMenuOpen(!menuOpen)}
    className="menu-icon"
    aria-label="Toggle navigation"
  >
    ☰
  </button>
        </div>
      </div>

      {/* Mobile Navigation */}
{menuOpen && (
  <div className="nav-overlay">
    <div className="nav-links-dropdown">
      <a
        onClick={() => {
          setMenuOpen(false);
          aboutRef.current?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="mobile-btn"
      >
        About
      </a>

      <a
        onClick={() => {
          setMenuOpen(false);
          featuresRef.current?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="mobile-btn"
      >
        Features
      </a>

      <a href="/blog" className="mobile-btn" onClick={() => setMenuOpen(false)}>
        Blog
      </a>

      <a
        onClick={() => {
          setMenuOpen(false);
          contactRef.current?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="mobile-btn"
      >
        Contact
      </a>

      {!user ? (
        <button
          onClick={() => {
            setMenuOpen(false);
            window.location.href = "/signin";
          }}
          className="mobile-btn"
        >
          Sign In
        </button>
      ) : (
        <button
          onClick={() => {
            setMenuOpen(false);
            handleSignOut();
          }}
          className="mobile-btn"
        >
          Sign Out
        </button>
      )}

      <button
        onClick={() => {
          setMenuOpen(false);
          handleUploadClick();
        }}
        className="mobile-btn"
      >
        Start Now
      </button>
    </div>
  </div>
)}

    </header>
  );
};



const Hero = () => {
  const [user, setUser] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleUploadClick = (e) => {
    e.preventDefault();
    if (user) {
      navigate("/upload");
    } else {
      alert("You must sign in first to start uploading files.");
    }
  };

  return (
    <div>
      <Helmet>
  <title>Life Storage Vault – Secure Your Digital Legacy for Free</title>
  <meta name="description" content="Create your own Life Storage Vault to keep your life’s story safe. Store unlimited photos and videos with complete control and peace of mind." />
  <meta name="keywords" content="best cloud storage, Storage Space,Free Cloud Storage,cloud storage pricing,Life Storage,Secure Photo Vault,Instant Memory Locker,Forever Video Vault,Unlimited Storage Space,Easy Memory Upload,Private Cloud Backup" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Preserve Your Memories Forever" />
  <meta property="og:description" content="Explore how Trinetra Visuals helps preserve every memory beautifully and securely." />
  <meta property="og:image" content="https://i.pinimg.com/736x/89/a7/11/89a711e1bc9dc6b8fc7c087de371524d.jpg" />
  <meta property="og:url" content="https://yourdomain.com/" />
  <meta name="twitter:card" content="summary_large_image" />
</Helmet>
    <section
      style={{
        position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    margin: 0,
    padding: 0,
      }}
    >
      {/* Fullscreen Background Video */}
    <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        {isMobile ? (
         <img
            src="https://i.pinimg.com/736x/89/a7/11/89a711e1bc9dc6b8fc7c087de371524d.jpg"
            alt="Storage Space"
            style={{
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
            }}
          />
        ) : (
          <img
            src="https://i.pinimg.com/736x/89/a7/11/89a711e1bc9dc6b8fc7c087de371524d.jpg"
            alt="Storage Space"
            style={{
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
            }}
          />
        )}
      </div>

      {/* Overlay Text Content (Centered) */}
      <div
        style={{
          marginBottom: "4rem" ,
          position: "relative",
          zIndex: 2,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? "20px" : "60px",
          textAlign: "center",
          color: "white",
          // Optional: soft white overlay for contrast
        }}
      >
        <h1  className="animated-text animated-delay-3"
        style={{ fontSize: isMobile ? "2rem" : "3.5rem", fontWeight: "700" ,marginTop: "11rem"}}>
          Because Every Memory
        </h1>
        <h1  className="animated-text animated-delay-2"style={{ fontSize: isMobile ? "2rem" : "3.5rem", fontWeight: "700", marginBottom: "1rem" }}>
          Deserves to Live Forever
        </h1><br></br>
       
        <div
         className="animated-text animated-delay-3"
  style={{
    display: "flex",
    gap: "20px", // spacing between buttons
    justifyContent: "center", // center them horizontally
    flexWrap: "wrap", // allows stacking on small screens
  }}
>
  <a
    href="/upload"
    onClick={handleUploadClick}
    style={{
      padding: "14px 28px",
      backgroundColor: "#DEB373",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      textDecoration: "none",
      fontWeight: "600",
      fontSize: "1rem",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor ="rgb(193, 147, 77)";
      e.target.style.boxShadow = "0 6px 14px rgba(0, 0, 0, 0.3)";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "#DEB373";
      e.target.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    Start Your Memory Journey
  </a>

  <a
    href="/upload"
    onClick={handleUploadClick}
    style={{
      padding: "14px 28px",
      backgroundColor: "#322016",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      textDecoration: "none",
      fontWeight: "600",
      fontSize: "1rem",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor ="rgb(54, 40, 32)";
      e.target.style.boxShadow = "0 6px 14px rgba(0, 0, 0, 0.3)";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "#322016";
      e.target.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    Explore How Works
  </a>
</div>

      </div>
    </section>
    </div>
  );
};

const HowItWorks = () => {
  const worksProcess = [
    {
      title: 'Create Your Vault',
      description: 'See your magic vault',
      icon: <FaWallet className="icon" />,
    },
    {
      title: 'Upload Your Moments',
      description: 'Upload your moments',
      icon: <FaCloudUploadAlt className="icon" />,
    },
    {
      title: 'Relive Anytime',
      description: 'Forever',
      icon: <FaRedo className="icon" />,
    },
  ];

  return (
      <section id="features" className="feature-container">
      <h2 className="how-title" color="white">How It Works</h2>
        <div className="grid">
          {worksProcess.map((feature, index) => (
            <div key={index} className="card">
              {feature.icon}
              <h3 className="card-title">{feature.title}</h3>
              {feature.description && (
                <p className="card-description">{feature.description}</p>
              )}
            </div>
          ))}
        </div>
        
    </section>
  );
};


const FeaturedStories = ({ refProp }) => {
  const scrollRef = useRef(null);
    const speed = 0.5; 

  const stories = [
    {
      id: 'emma-liam',
      title: 'Emma & Liam',
      subtitle: 'Baby Album',
      image: 'https://cdn.pixabay.com/photo/2020/04/13/06/12/newborn-5036843_1280.jpg',
      alt: 'Storage Space',
      button: { text: 'See Their Journey', disabled: false },
    },
    {
      id: 'abigail-wedding',
      title: 'Abigail’s',
      subtitle: 'Wedding Journey',
      image: 'http://cdn.pixabay.com/photo/2016/06/29/08/41/wedding-dresses-1486256_1280.jpg',
      alt: 'Free Cloud Storage',
      button: { text: 'See Their Journey', disabled: false },
    },
    {
      id: 'mom-dad',
      title: 'Mom & Dad’s 25th',
      subtitle: 'Silver Anniversary',
      image: 'https://i.pinimg.com/736x/d0/26/65/d02665fc66e2f63775edbede165c45fc.jpg',
      alt: 'Life Storage',
      button: { text: 'See Memories', disabled: false },
    },
    {
      id: 'Emily’s-graduction',
      title: 'Emily’s Achievement',
      subtitle: 'Graduation Day',
      alt: 'Secure Photo Vault',
      image: 'https://i.pinimg.com/736x/ce/16/76/ce16762c6d3aef5699e55e94968aa922.jpg',
      button: { text: 'View Celebration', disabled: false },
    },
    {
      id: 'Henry’s-birth',
      title: 'Henry’s 80th',
      subtitle: 'Birthday',
      image: 'https://i.pinimg.com/736x/1f/66/cb/1f66cbd5fc4bb2e6256e6134515f9746.jpg',
      alt:'Instant Memory Locker',
      button: { text: 'Coming Soon', disabled: true },
    },
    {
      id: 'Bali',
      title: 'Backpacking in Bali',
      subtitle: 'A Soul-Searching Solo Journey',
      image: 'https://i.pinimg.com/originals/86/ac/e1/86ace1b304a4de651eee81804bedd1b1.jpg',
       alt:'Forever Video Vault',
      button: { text: 'Coming Soon', disabled: true },
    },
  ];
    // Duplicate the stories for infinite scroll
  const duplicatedStories = [...stories, ...stories];
useEffect(() => {
    const track = scrollRef.current;
    let animationId;

    const loop = () => {
      if (track) {
        track.scrollLeft += speed;

        // Reset scroll to simulate infinite scroll
        if (track.scrollLeft >= track.scrollWidth / 2) {
          track.scrollLeft = 0;
        }
      }

      animationId = requestAnimationFrame(loop);
    };

    loop();

    return () => cancelAnimationFrame(animationId);
  }, []);





  return (
       <div className="story-scroll-container" ref={refProp}>
        <h1 className="story-h1 ">Features Stories</h1>
      <div className="story-scroll-track" ref={scrollRef}>
        <div className="story-grid">
          {duplicatedStories.map((story, index) => (
            <div className="story-card" key={index}>
              <img src={story.image} alt={story.title} className="story-image" />
              <h3 className="story-title">{story.title}</h3>
              <p className="story-subtitle">{story.subtitle}</p>
              {story.button.disabled ? (
                <button className="story-button disabled" disabled>{story.button.text}</button>
              ) : (
                <Link to={`/journey/${story.id}`}>
                  <button className="story-button">{story.button.text}</button>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

const ScrollerText = () => {
  const repeatedText = "Secure. Simple. Scalable. ";

  return (
    <div className="scroller-container">
      <div className="scroller-track">
        <span className="scroller-text">
          {repeatedText.repeat(50)}
        </span>
        <span className="scroller-text">
          {repeatedText.repeat(50)}
        </span>
      </div>
    </div>
  );
};

const MemoryHero = () => {
    const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();
    const textRef = useRef(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, [auth]);

   const handleUploadClick = (e) => {
    e.preventDefault();
    if (user) {
      navigate("/upload");
    } else {
      alert("You must sign in first to start uploading files.");
    }
  };
    useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          textRef.current.classList.add("visible");
        }
      },
      {
        threshold: 0.5, // Trigger when 50% is visible
      }
    );

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);
  return (
    <section className="memory-hero">
      <div className="overlay">
        <div className="text-container" ref={textRef}>
          <h1>Preserve Your<br />Lifetime of Memories</h1>
          <p>
            Store photos and videos capturing precious moments<br />
            from birth to death, creating a personal digital<br />
            legacy for generations to come.
          </p>
          <button onClick={handleUploadClick}>Get Started</button>
        </div>
      </div>
    </section>
  );
};

const MemoryTimeline = () => {
  const milestones = ['Birth', 'Childhood', 'First Love', 'Marriage', 'Legacy'];

  return (
    <div className="timeline-section">
      <h2>Memory Timeline</h2>
      <div className="timeline">
        {milestones.map((milestone, index) => (
          <div className="timeline-item" key={index}>
            <span className="label">{milestone}</span>
            <span className="dot"></span>
          </div>
        ))}
        <div className="line"></div>
      </div>
    </div>
  );
};


const WhyDifferent=  ({ refProp })  =>{
const cards = [
  {
    icon: <FaBox className="icon" />,
    title: 'Built to Last',
    description: 'Your stories unite devices and genres.'
  },
  {
    icon: <FaShieldAlt className="icon"/>,
   title: 'Trust & Transparency',
  description: 'We protect your data and never compromise .'
  },
  {
    icon: <FaGift className="icon" />,
    title: 'Free Forever',
    description: 'Our commitment to humanity, not rev us.'
  }
];
  return (
    <section className="why-section" ref={refProp}>
      <h2>Why Lifoura is Different</h2>
      <div className="why-cards">
        {cards.map((card, index) => (
          <div className="why-card" key={index}>
            <div className="icon">{card.icon}</div>
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

const Footer = ({ refProp ,aboutRef}) => {
   const navigate = useNavigate();
     const handlePrivacy = (e) => {
    e.preventDefault();
      navigate("/privatepolicy");
  };
      const handleTerms = (e) => {
    e.preventDefault();
      navigate("/termsOfService");
  };
  return (
    <footer className="footer"  ref={refProp}>
      <div className="footer-container">
        {/* Branding */}
        <div className="footer-brand">
          <h3>Lifoura</h3>
          <p>© {new Date().getFullYear()} Lifoura. All rights reserved.</p>
         <strong>Contact:</strong> <a href="mailto:support@lifoura.com" class="email-link">support@lifoura.com</a><br />
        </div>

        {/* Navigation Links */}
        <div className="footer-links">
          <a onClick={() => aboutRef.current?.scrollIntoView({ behavior: 'smooth' })}>About Us</a>
          <a onClick={handlePrivacy}>Privacy Policy</a>
          <a onClick={handleTerms}>Terms of Service</a>
        </div>

        {/* Social Icons */}
        <div className="footer-socials">
          <a href="https://www.facebook.com/people/Lifoura/61577731213049/" aria-label="Facebook"><FaFacebookF /></a>
          <a href="" aria-label="Twitter"><FaTwitter /></a>
          <a href="https://www.instagram.com/lif.oura/" aria-label="Instagram"><FaInstagram /></a>
          <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
        </div>
      </div>
    </footer>
  );
};



const App = () => {
   const aboutRef = useRef(null);
  const featuresRef = useRef(null);
  const contactRef = useRef(null);
  return (
    <div>
      <Navbar aboutRef={aboutRef}featuresRef={featuresRef}contactRef={contactRef} />
      <Hero />
      <HowItWorks />
      <FeaturedStories refProp={featuresRef}/>
      <MemoryHero />
      <ScrollerText /><br></br><br></br>
      <MemoryTimeline />
      <WhyDifferent refProp={aboutRef} />
      
      <Footer refProp={contactRef}/>
     
      
    </div>
  );
};

export default App;
